import { Card, Form } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import { useEffect, useState } from "react";
import AddAboutMain from "./AddAboutMain";
import WebService from "../../utility/WebService";
import HelperService from "../../utility/HelperService";
// import "../../assets/css/quill-size.css";
import "quill-table-better/dist/quill-table-better.css";
import "quill-resize-module/dist/resize.css"; // ✅ IMPORTANT (image handles)


const AboutMain = () => {
  const [showAddAbout, setShowAddAbout] = useState(false);
  const [aboutData, setAboutData] = useState<any>(null);
  const [pagePermission, setPagePermission] = useState({
    canView: false,
    canAdd: false,
    canEdit: false,
    canDelete: false,
  });
  useEffect(() => {
    getAbout();
  }, []);

  const getAbout = () => {
    WebService.getAPI({
      action: `about/getAbout`,
    })
      .then((res: any) => {
        setAboutData(res.data);
        const perm = res?.data?.permissions || {};
        setPagePermission({
          canView: perm.canView,
          canAdd: perm.canAdd,
          canEdit: perm.canEdit,
          canDelete: perm.canDelete,
        });
      })
      .catch((err: any) => {
        console.error(err);
      });
  };

  return (
    <>
      <AddAboutMain
        show={showAddAbout}
        handleClose={() => {
          setShowAddAbout(false);
          getAbout();
        }}
        data={aboutData}
      />
      <div className="events-main">
        <Card className="event-card">
          <div className="d-flex justify-content-between">
            <div className="page-title">About IESA</div>
            {pagePermission.canEdit && (
              <CustomButton
                isLoading={false}
                label={aboutData == null ? "Add" : "Edit"}
                onClick={() => {
                  // setEventToEdit(null)
                  setShowAddAbout(true);
                }}
                style={{ width: 100 }}
              />)}

          </div>
          {aboutData == null ? (
            <div className="text-center mt-3">
              No About information available
            </div>
          ) : (
            <span className="mt-3 d-block" style={{ padding: "20px 30px" }}>

              <img src={aboutData?.banner} alt="About Banner" width={250} />
              <div className="ql-snow">
                <div
                  className="mt-2 px-0 ql-editor"
                  dangerouslySetInnerHTML={{ __html: HelperService.getPreviewableHTML(aboutData.description) }}
                />
              </div>

              <hr />
                {/* ================= VISION ================= */}
                {aboutData.vision?.length > 0 && (
                  <>
                    <h5 className="mt-4 mb-3 fw-bold">Vision</h5>
                    <div className="row">
                      {aboutData.vision.map((vision: any, index: number) => (
                        <div key={index} className="col-md-6 mb-3">
                          <div className="p-3 border rounded-3 h-100 bg-light">
                            <div className="d-flex align-items-center mb-2">
                              {vision.icon && (
                                <img
                                  src={vision.icon}
                                  alt={vision.title}
                                  width={35}
                                  height={35}
                                  className="me-2"
                                />
                              )}
                              <h6 className="mb-0 fw-semibold">{vision.title}</h6>
                            </div>

                            <div
                              className="text-muted small"
                              dangerouslySetInnerHTML={{
                                __html: HelperService.getPreviewableHTML(
                                  vision.description
                                ),
                              }}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </>
                )}    
                <hr />          
                {/* ================= MISSION ================= */}
                {aboutData.mission?.length > 0 && (
                  <>
                    <h5 className="mt-4 mb-3 fw-bold">Mission</h5>
                    <div className="row">
                      {aboutData.mission.map((mission: any, index: number) => (
                        <div key={index} className="col-md-6 mb-3">
                          <div className="p-3 border rounded-3 h-100 bg-light">
                            <div className="d-flex align-items-center mb-2">
                              {mission.icon && (
                                <img
                                  src={mission.icon}
                                  alt={mission.title}
                                  width={35}
                                  height={35}
                                  className="me-2"
                                />
                              )}
                              <h6 className="mb-0 fw-semibold">{mission.title}</h6>
                            </div>

                            <div
                              className="text-muted small"
                              dangerouslySetInnerHTML={{
                                __html: HelperService.getPreviewableHTML(
                                  mission.description
                                ),
                              }}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </>
                )}
                <hr />
                {/* ================= HIGHLIGHTS ================= */}
                {aboutData.highlights?.length > 0 && (
                  <>
                    <h5 className="mt-4 mb-3 fw-bold">Highlights</h5>
                    <div className="d-flex flex-wrap gap-2">
                      {aboutData.highlights.map((highlight: any, index: number) => (
                        <div
                          key={index}
                          className="d-flex align-items-center px-3 py-2 border rounded-pill bg-white shadow-sm"
                        >
                          {highlight.icon && (
                            <img
                              src={highlight.icon}
                              alt={highlight.title}
                              width={40}
                              height={40}
                              className="me-2"
                            />
                          )}
                          <span className="small fw-medium">{highlight.title}</span>
                        </div>
                      ))}
                    </div>
                  </>
                )}       
            </span>
          )}
        </Card>
      </div>
    </>
  );
};

export default AboutMain;
